export const replaceVisualBrand = text => {
  if (typeof text !== 'string') return text;

  const installationName =
    window.globalConfig?.INSTALLATION_NAME || 'Chat Fystec';

  return text
    .split(/(https?:\/\/\S+)/)
    .map(part => {
      if (/^https?:\/\//.test(part)) return part;

      return part
        .replace(/chatwoot/gi, installationName)
        .replace(/fazer\.ai\b/gi, installationName);
    })
    .join('');
};
